export default "__VITE_ASSET__DJ0J5APH__"